import _, { reject } from "lodash";
import apis from "../../utils/apis";
// import Result from "../../pages/Result";
import axios from "axios";
import {
  saveToSessionStorage,
  setIsReferralUsers,
  setUserRefId,
} from "../../utils/storage";
import { setUserOldForm } from "../../redux/action/setOldForm";
import { setUserPreviousResult } from "../../redux/action/setPreviousResult";
import { setUserResult } from "../../redux/action/result";
import { setUserStatus } from "../../redux/action/user";
import { setResultId } from "../../redux/action/result";
// import {
//   setReferralList,
//   updateReferralList,
// } from "../../redux/action/setReferralsList";
import toast from "react-hot-toast";
import ReactGA4 from "react-ga4";
import { setLoading } from "../../redux/action/loadingRequest";

export const getPublicResult = async (
  dispatch,
  setUserPublicResult,
  uuid,
  setPageLoading,
  setErrorPublicPage
) => {
  apis
    .GET({
      endpoint: `/get-public-carousel-page?id=${uuid}`,
      options: { type: "json" },
    })
    .then((object) => {
      if (object.status === 201) {
        dispatch(setUserPublicResult(object.data.data));
        // dispatch(setLoading(false));
        setPageLoading(false);
      } else {
        console.log(object.response.data, "error data");
        setPageLoading(false);
      }
    })
    .catch((error) => {
      console.log(error, "error in catch block");
      setPageLoading(false);
      setErrorPublicPage({
        error: true,
        message: error.response.data,
        status: error.response.status,
      });
      console.log(error, "error component called");
    });
};

export const getResultPageCarousel = async (
  dispatch,
  setResultPageCarousel
) => {
  try {
    // Fetch result page carousel
    const carouselResponse = await apis.GET({
      endpoint: "/get-result-page-carousel-sections",
      options: { type: "json" },
    });

    if (carouselResponse?.status === 201) {
      // Sort the carousel sections by order
      const orderedCarouselSections = carouselResponse.data.sort(
        (a, b) => a.order - b.order
      );
      dispatch(setResultPageCarousel(orderedCarouselSections));
    }
  } catch (error) {
    // console.error("Error in getResultPageCarousel:", error);
    // toast.error("An error occurred while fetching the carousel data.");
  }
};

const path = sessionStorage.getItem("targetPath") || "/";
export const userLogin = async (
  payload,
  navigate,
  dispatch,
  setUserStatus
) => {
  apis
    .POST({
      endpoint: "/create-user",
      payload: payload,
      options: { type: "json" },
    })
    .then((object) => {
      // window.location.replace("/");
      setIsReferralUsers(object?.data?.isReferralUsers);
      setUserRefId(object?.data?.userRefId);
      // console.log(object.data?.isReferralUsers, "isReferralUsers");
      // setIsReferralUsers(object?.data?.isReferralUsers);
      // console.log(object.data?.isReferralUsers, "isReferralUsers");
      // getPreviousResult(dispatch);
      saveToSessionStorage("uuid", object?.data?.uuid);
      dispatch(
        setUserStatus({
          isLoggedIn:
            sessionStorage.getItem("isLoggedIn") === "true" ? true : false,
          userRefId: sessionStorage.getItem("userRefId"),
          loading: false,
          uuid: object?.data?.uuid,
          viewAsRecruiter: object?.data?.viewAsRecruiter ?? false, // Dispatch the value
          superAdmin: object?.data?.superAdmin ?? false, // Dispatch the value
        })
      );
      if (object?.data?.uuid || object?.data?.userRefId) {
        ReactGA4.event("user_login_success", {
          user_ref_id: object.data.userRefId || object.data.uuid,
          login_method: "email_otp",
        });
      }

      // Check for pending all-elements redirect
      const pendingAllElementsPath = localStorage.getItem("pendingAllElementsPath");
      const pendingAllElementsId = localStorage.getItem("pendingAllElementsId");
      const priorityRedirect = localStorage.getItem("priorityAllElementsRedirect");
      
      if (pendingAllElementsId && pendingAllElementsPath) {
        // Clear the stored values
        localStorage.removeItem("pendingAllElementsId");
        localStorage.removeItem("pendingAllElementsPath");
        localStorage.removeItem("priorityAllElementsRedirect");
        
        // Use setTimeout to ensure the redirect happens after the current execution context
        setTimeout(() => {
          navigate(pendingAllElementsPath);
        }, priorityRedirect === "true" ? 50 : 100); // Faster redirect for cvscore
        return;
      }

      const urlSearchString = window.location.search;
      const params = new URLSearchParams(urlSearchString);
      const redirectLink = params.get("link");
      if (redirectLink === "/endorse-expertise") {
        navigate("/endorse-expertise");
      } else {
        navigate(path);
      }
    });
};

export const googleUserLogin = async (
  payload,
  dispatch,
  setUserStatus,
  setLoading
) => {
  apis
    .POST({
      endpoint: "/create-user",
      payload: payload,
      options: { type: "json" },
    })
    .then((object) => {
      setIsReferralUsers(object?.data?.isReferralUsers);
      setUserRefId(object?.data?.userRefId);
      saveToSessionStorage("uuid", object?.data?.uuid);
      saveToSessionStorage("userRefId", object?.data?.userRefId);
      dispatch(
        setUserStatus({
          isLoggedIn:
            sessionStorage.getItem("isLoggedIn") === "true" ? true : false,
          userRefId: object?.data?.userRefId,
          uuid: object?.data?.uuid,
          viewAsRecruiter: object?.data?.viewAsRecruiter,
          superAdmin: object?.data?.superAdmin ?? false, // Dispatch the value
        })
      );
      dispatch(setLoading(false));
      
      // Clear pending all-elements data after successful social login
      // The redirect will be handled by Amplify OAuth redirect mechanism
      localStorage.removeItem("pendingAllElementsId");
      localStorage.removeItem("pendingAllElementsPath");
      
      if (object?.data?.uuid || object?.data?.userRefId) {
        ReactGA4.event("user_login_success", {
          user_ref_id: object.data.userRefId || object.data.uuid,
          login_method: "social_oauth",
        });
      }
    });
};
export const isReferralUser = async (setUserStatus, dispatch) => {
  apis
    .GET({
      endpoint: "/get-isReferralUser",
      options: { type: "json" },
    })
    .then((object) => {
      dispatch(
        setUserStatus({
          isLoggedIn: sessionStorage.getItem("isLoggedIn"),
          isReferralUsers: object?.data?.isReferralUsers,
        })
      );
    });
};

export const fetchResumeQuestionJson = async (
  dispatch,
  setResumeQuestionJson
) => {
  try {
    const response = await apis.GET({
      endpoint: "/get-resume-carousel-questionForm",
      options: { type: "json" },
    });
    dispatch(setResumeQuestionJson(response.data));
  } catch (error) {
    console.error("Error fetching resume question form:", error);
  }
};

export const getResult = (
  userFormObject,
  setFinalResult,
  dispatch,
  setUserResult,
  setLoading,
  navigate,
  razorpay_payment_id,
  amount,
  invoiceDetails
) => {
  apis
    .POST({
      endpoint: "/get-result",
      payload: userFormObject,
      options: {
        type: "json",
      },
      dispatch,
      navigate,
      setUserResult,
    })
    .then((object) => {
      // console.log("object", object);
      // if (object?.status === 201) {
      //   window.sendinblue.track("done_result", {
      //     email: localStorage.userEmail,
      //   });
      // }
      setFinalResult(object?.data);
      object.data.razorpay_payment_id = razorpay_payment_id;
      object.data.amount = amount;

      dispatch(setUserResult(object?.data));
      dispatch(setUserOldForm(userFormObject));
      navigate(`/result/${object?.data?._id}`);
      dispatch(setLoading(false));
      if (object?.data?.amount > 0) {
        apis
          .POST({
            endpoint: "/payment",
            payload: {
              ResultId: object?.data?._id,
              amount: amount * 100,
              currency: "INR",
              razorpay_payment_id: razorpay_payment_id,
              date: new Date(Date.now()).toUTCString(),
              invoice: invoiceDetails,
            },
            options: {
              type: "json",
            },
          })
          .then(function (response) {
            // console.log(response);
          })
          .catch(function (error) {
            // console.log(error);
          });
      }
      // return <Result />;
    });
};
export const getResults = (setResults) => {
  apis
    .GET({
      endpoint: "/get-results",
      options: {
        type: "json",
      },
    })
    .then((object) => {
      // console.log("data helper", object.data);
      setResults(object?.data?.result);
      // return object.data;
    });
};
export const UserStatus = () => {
  apis
    .GET({
      endpoint: "/get-results",
      options: {
        type: "json",
      },
    })
    .then((object) => {
      // console.log("data helper", object.data);
      // setResults(object?.data?.result);
      // return object.data;
    });
};

export const saveUserTheme = async (currentTheme, currentFont) => {
  try {
    const response = await apis.POST({
      endpoint: "/save-user-theme",
      payload: {
        themes: {
          currentTheme: currentTheme,
          font: currentFont,
        },
      },
      options: { type: "json" },
    });
    if (response.status === 201) {
      console.log("Theme and font saved successfully:", response.data);
    } else {
      console.error("Failed to save theme and font:", response.data);
    }
  } catch (error) {
    console.error("Error saving theme and font:", error);
  }
};

export const fetchUserTheme = async () => {
  try {
    const response = await apis.GET({
      endpoint: "/get-user-theme",
      options: { type: "json" },
    });
    if (response.status === 201) {
      return response.data; // Return the saved theme and font
    } else {
      console.error("Failed to fetch theme and font:", response.data);
      return null;
    }
  } catch (error) {
    console.error("Error fetching theme and font:", error);
    return null;
  }
};
